import { useState } from 'react';
import { faqs } from '@/mocks/home';

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <span className="inline-flex items-center gap-2 text-sm font-label font-medium text-primary-700">
                <span className="w-6 h-[2px] bg-primary-500" aria-hidden="true"></span>
                常见问题
              </span>
              <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
                关于本站，你可能想问
              </h2>
              <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
                汇总了用户最常咨询的几个问题。如果这里没有覆盖你的疑问，欢迎通过页面底部的联系表单告诉我们。
              </p>
              <a
                href="#contact"
                className="mt-6 inline-flex items-center gap-2 text-sm font-label font-medium text-primary-700 hover:text-primary-800 transition-colors cursor-pointer"
              >
                前往联系表单
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="flex flex-col gap-3">
              {faqs.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <article
                    key={item.q}
                    className={`bg-background-50 border rounded-lg overflow-hidden transition-colors ${
                      isOpen ? 'border-primary-300' : 'border-background-200'
                    }`}
                  >
                    <h3>
                      <button
                        type="button"
                        onClick={() => setOpenIndex(isOpen ? null : index)}
                        className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer"
                        aria-expanded={isOpen}
                      >
                        <span className="font-heading font-semibold text-sm md:text-base text-foreground-950 leading-snug">
                          {item.q}
                        </span>
                        <span
                          className={`w-8 h-8 shrink-0 flex items-center justify-center rounded-full transition-colors ${
                            isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'
                          }`}
                        >
                          <i
                            className={isOpen ? 'ri-subtract-line' : 'ri-add-line'}
                            aria-hidden="true"
                          ></i>
                        </span>
                      </button>
                    </h3>
                    {isOpen && (
                      <div className="px-5 md:px-6 pb-5 md:pb-6">
                        <p className="text-sm leading-relaxed text-foreground-600 border-t border-background-200 pt-4">
                          {item.a}
                        </p>
                      </div>
                    )}
                  </article>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}